/**
 * Salesforce Web-to-Case settings for cancel-membership (and similar forms).
 * Values are supplied per deploy via .env / .env.prod (see .env.* in repo root).
 */

const {
  REACT_APP_SALESFORCE_WEB_TO_CASE_HOST,
  REACT_APP_SALESFORCE_ORG_ID,
  REACT_APP_SALESFORCE_WEB_TO_CASE_RECORD_TYPE_ID,
  REACT_APP_SALESFORCE_W2C_FIELD_REFUND_TARGET,
  REACT_APP_SALESFORCE_W2C_FIELD_GIFT_RECIPIENT,
  REACT_APP_SALESFORCE_W2C_FIELD_CANCEL_REASON,
  REACT_APP_SALESFORCE_W2C_USE_RECAPTCHA,
  REACT_APP_SALESFORCE_RECAPTCHA_SITE_KEY,
  REACT_APP_SALESFORCE_RECAPTCHA_KEYNAME,
  REACT_APP_SALESFORCE_W2C_CANCEL_REASON_OTHER_PURCHASE
} = process.env;

const orgId = REACT_APP_SALESFORCE_ORG_ID ?? "";
const webToCaseHost = REACT_APP_SALESFORCE_WEB_TO_CASE_HOST ?? "";

export const salesforceWebToCaseFieldIds = {
  refundTarget: REACT_APP_SALESFORCE_W2C_FIELD_REFUND_TARGET ?? "",
  giftRecipient: REACT_APP_SALESFORCE_W2C_FIELD_GIFT_RECIPIENT ?? "",
  cancelReason: REACT_APP_SALESFORCE_W2C_FIELD_CANCEL_REASON ?? ""
} as const;

export const salesforceWebToCaseConfig = {
  orgId,
  recordTypeId: REACT_APP_SALESFORCE_WEB_TO_CASE_RECORD_TYPE_ID ?? "",
  formAction:
    webToCaseHost && orgId
      ? `https://${webToCaseHost}/servlet/servlet.WebToCase?encoding=UTF-8&orgId=${orgId}`
      : "",
  useRecaptcha: REACT_APP_SALESFORCE_W2C_USE_RECAPTCHA === "true",
  recaptchaSiteKey: REACT_APP_SALESFORCE_RECAPTCHA_SITE_KEY ?? "",
  recaptchaKeyname: REACT_APP_SALESFORCE_RECAPTCHA_KEYNAME ?? "",
  isConfigured:
    Boolean(webToCaseHost && orgId) &&
    Boolean(salesforceWebToCaseFieldIds.refundTarget) &&
    Boolean(salesforceWebToCaseFieldIds.giftRecipient) &&
    Boolean(salesforceWebToCaseFieldIds.cancelReason)
} as const;

export function buildSalesforceCaptchaSettingsJson(): string {
  return JSON.stringify({
    keyname: salesforceWebToCaseConfig.recaptchaKeyname,
    fallback: "true",
    orgId: salesforceWebToCaseConfig.orgId,
    ts: ""
  });
}

const CANCEL_REFUND_TARGET_OPTIONS = [
  { value: "My own membership", label: "My own membership" },
  { value: "A gift purchase", label: "A gift purchase" }
] as const;

export function getCancelReasonOptions(): Array<{ value: string; label: string }> {
  const otherPurchase =
    REACT_APP_SALESFORCE_W2C_CANCEL_REASON_OTHER_PURCHASE?.trim() ||
    "I need to purchase for someone else";

  return [
    {
      value: "I used the wrong credit card",
      label: "I used the wrong credit card"
    },
    { value: otherPurchase, label: otherPurchase },
    {
      value: "I want to send to a different person",
      label: "I want to send to a different person"
    },
    {
      value: "I decided it was too expensive",
      label: "I decided it was too expensive"
    },
    { value: "I changed my mind", label: "I changed my mind" }
  ];
}

export { CANCEL_REFUND_TARGET_OPTIONS };
